import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDistributorMovingAverage = createAsyncThunk("fetchDistributorMovingAverage", async ({ page, limit, filters }) => {
	const params = new URLSearchParams({
		page: page || 1,
		limit: limit || 10,
		distributorid: filters?.distributorid?.trim() || "",
		product_id: filters?.product_id?.trim() || "",
	});

	const response = await axiosHttp.get(`distributor/movingaverage?${params}`);
	return response.data;
});

const DistributorMovingAverageSlice = createSlice({
	name: "DistributorMovingAverageSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		total: 0,
		page: 1,
		limit: 10,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDistributorMovingAverage.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchDistributorMovingAverage.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload?.data;
			state.total = action.payload.pagination?.totalRecords || 0;
			state.page = action.payload.pagination.currentPage || 1;
		});
		builder.addCase(fetchDistributorMovingAverage.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload.data;
		});
	},
});

export default DistributorMovingAverageSlice.reducer;
